<span class="btn-group" placement="bottom-right">
  <span class="clock" aria-haspopup="true" aria-expanded="false" (dblclick)="onDblClick()" data-test="header-clock-button">
    {{ clock$ | async | date:'HH:mm' : timeZone }}
  </span>
</span>
